import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { forkJoin } from "rxjs";

@Injectable()
export class CiacService {
  constructor(public http: HttpClient) {}

  getCatalogos() {
    const urlColonias = environment.URL_CIAC + "/colonias";
    const urlServicios = environment.URL_CIAC + "/servicios_publicos";
    const colonias = this.http.get<any>(urlColonias);
    const servicios = this.http.get<any>(urlServicios);
    return forkJoin([colonias, servicios]);
  }
  getCatalogosColonias(){
    const urlColonias = environment.URL_CIAC + "/colonias";
    var promise = new Promise((resolve, reject) => {
    const headers = new HttpHeaders()
      .set("mini-ciac", "5a508afd0c735ec71231b0d4fa7c8a3d");

    this.http
      .get(
        urlColonias,{ headers }).subscribe((data:any)=>{
     //     console.log(data)
          resolve(data.registros)
         // console.log(data.registros)
        })
      })
      return promise;
  }
  getCatalogosServicios() {
    const urlColonias = environment.URL_CIAC + "/servicios_publicos";
    var promise = new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("mini-ciac", "5a508afd0c735ec71231b0d4fa7c8a3d");

      this.http
        .get(
          urlColonias, { headers }).subscribe((data: any) => {
          
            resolve(data.registros)
            // console.log(data.registros)
          })
    })
    return promise;
  }

  agregarSolicitud(solicitud: any, ficonstoUpload: File) {
    // tslint:disable-next-line:prefer-const

    var promise = new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("mini-ciac", "5a508afd0c735ec71231b0d4fa7c8a3d");

        const url = environment.URL_CIAC + "/solicitud_nld";
     

        const formData: FormData = new FormData();
        formData.append("imagen", ficonstoUpload);
        formData.append("data", JSON.stringify(solicitud));

      return this.http.post(url, formData, { headers }).pipe(
          map((resp: any) => {
            return resp;
          })
        );
    })
    return promise;
  }
  agregarSolicitud2(solicitud: any, ficonstoUpload: File) {
   

    var promise = new Promise((resolve, reject) => {

      const headers = { 'mini-ciac': '5a508afd0c735ec71231b0d4fa7c8a3d'};
      const url = environment.URL_CIAC + "/solicitud_nld";

      const formData: FormData = new FormData();
      formData.append("imagen", ficonstoUpload);
      formData.append("data", JSON.stringify(solicitud));

      this.http.post<any>(url, formData, { headers }).subscribe(data => {
      resolve(data)
      });


    })
    return promise;
  }

  Impresion(idsolicitud) {



    var promise = new Promise((resolve, reject) => {

    let url = environment.URL_CIAC + "/pdf_formato_solicitud";


    const headers = new HttpHeaders().set('mini-ciac', '5a508afd0c735ec71231b0d4fa7c8a3d');
    this.http.post(url, {idsolicitud}, { headers, responseType: 'blob' }).subscribe((resp)=>{
      //console.log(resp)
      let downloadUrl = window.URL.createObjectURL(resp);
         window.open(downloadUrl);
       
     });
    })
    return promise;

  
  }
}
